"use client";
import { useEffect, useRef } from 'react';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import SuperTokens from 'supertokens-web-js';
import { SuperTokensConfig } from '../config';
import useScript from '@/hooks/customScriptHook';

if (typeof window !== 'undefined') {
    SuperTokens.init(SuperTokensConfig);
}

const ClientSideWrapper = ({ children }) => {
    const targetRef = useRef(null);

    return (
        <>
            <div ref={targetRef} style={{ height: '1px', width: '1px' }}></div>
            <SuperTokensWrapper>{children}</SuperTokensWrapper>
        </>
    );
};

export default ClientSideWrapper;
